import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { cloneDeep } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { Feature, PermissionContext } from "../../contexts/PermissionContext";
import { IComboBoxOption, IMaterial, IMaterialInformationFormSection } from "../../interfaces";
import { Sort, Values } from "../../utils";
import { DispatchNoteDialog } from "../DispatchNoteDialog";
import { DispatchRequestImageDialog } from "../DispatchRequestImageDialog";
import { MaterialConsumeDialog } from "../MaterialConsumeDialog";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { ConsumedMaterialTableRow } from "./ConsumedMaterialTableRow";
import { MaterialTableRow } from "./MaterialTableRow";

export const MaterialInformationForm: React.FC<IMaterialInformationFormSection> = ({
    entityId,
    entityReference,
    status,
    materials,
    images,
    onUpdateImages,
    onImportComplete,
    onConsume,
    readonly,
    readonlyMaterialActions,
    ...props
}: IMaterialInformationFormSection) => {


    const permissionContext = useContext(PermissionContext);

    const [returnStatuses, setReturnStatuses] = useState<IComboBoxOption[]>([]);

    const getMaterials = (statusId?: number) => {
        //deep copy the object
        let clone = cloneDeep(materials).filter(x => (x?.quantity ?? 0) > 0);

        //order materials alphabetically
        Sort.materials(clone);



        if (statusId)
            return clone.filter(x => x.statusId === statusId)

        return clone;

    }

    useEffect(() => {
        if (returnStatuses.length === 0)
            Values.setValues("expectedmaterialreturnstates", setReturnStatuses);
    }, [materials, images, returnStatuses.length])

    const MaterialTableHead = () => {
        return (<TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Vehicle Class</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Part Identification</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Expected Return Condition</TableCell>
                <TableCell />
            </TableRow>
        </TableHead>);
    }
    const ConsumedMaterialTableHead = () => {
        return (<TableHead>
            <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Vehicle Class</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Part Identification</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Qty</TableCell>
                <TableCell>Reason</TableCell>
                <TableCell />
            </TableRow>
        </TableHead>);
    }

    return (
        <Card>

            <FormSectionHeader label="Dispatched Materials" />

            <CardContent>

                <Grid container spacing={4}>
                    {materials.length > 0 ? <>
                        {
                            getMaterials(2).length > 0 &&
                            <Grid item xs={12}>

                                <Typography variant="h6" color="primary">Inventory Material</Typography>

                                <TableContainer>
                                    <Table>
                                        <MaterialTableHead />
                                        <TableBody>
                                            {materials.length > 0 && getMaterials(2).map((material, i) =>
                                                MaterialTableRow(
                                                    material,
                                                    returnStatuses,
                                                    () => { },
                                                    readonly,
                                                    () => { },
                                                    i
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        }
                        {
                            getMaterials(3).length > 0 &&
                            <Grid item xs={12}>

                                <Typography variant="h6" color="primary">Material Out</Typography>

                                <TableContainer>
                                    <Table>
                                        <MaterialTableHead />
                                        <TableBody>
                                            {materials.length > 0 && getMaterials(3).map((material, i) =>
                                                MaterialTableRow(
                                                    material,
                                                    returnStatuses,
                                                    () => { },
                                                    readonly,
                                                    () => { },
                                                    i
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                {status === 6 && <MaterialConsumeDialog
                                    materials={getMaterials(3)}
                                    onConsume={onConsume}
                                />}
                            </Grid>
                        }
                        {
                            getMaterials(4).length > 0 &&
                            <Grid item xs={12}>

                                <Typography variant="h6" color="primary">Material Out - Consumed</Typography>

                                <TableContainer>
                                    <Table>
                                        <ConsumedMaterialTableHead />
                                        <TableBody>
                                            {materials.length > 0 && getMaterials(4).map((material, i) =>

                                                ConsumedMaterialTableRow(
                                                    material,
                                                    returnStatuses,
                                                    () => { },
                                                    readonly,
                                                    () => { },
                                                    i
                                                )
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        }
                    </> :
                        <Grid item xs={12}>
                            <Typography
                                sx={{ pb: 2 }}
                                variant="subtitle2"
                            >
                                No material dispatched.
                            </Typography>
                        </Grid>
                    }
                    <Grid item>
                        {permissionContext.isPermitted(Feature.DispatchRequest_DispatchNote)
                            &&
                            <DispatchNoteDialog
                                dispatchRequestReference={entityReference ?? ""}
                                dispatchRequestId={entityId}
                                disabled={false}
                            />
                        }
                    </Grid>
                    <Grid item>
                        {permissionContext.isPermitted(Feature.DispatchRequest_DispatchNote)
                            &&
                            <DispatchRequestImageDialog
                                entityId={entityId}
                                images={images ?? []}
                                onImagesChanged={onUpdateImages ? onUpdateImages : () => { }}
                                readonly={readonlyMaterialActions}
                            />
                        }
                    </Grid>
                </Grid>

            </CardContent>
        </Card>
    );
}